import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/sys' : '/sys'

export function listData(data) {
  return request({
    url: urlPrefix + '/metashares/listdata',
    method: 'post',
    data
  })
}

export function getRefresherCol(data) {
  return request({
    url: urlPrefix + '/metashares/getRefresherCol',
    method: 'post',
    data
  })
}

export function getMsRatioList(data) {
  return request({
    url: urlPrefix + '/metashares/getMsRatioList',
    method: 'post',
    data
  })
}

export function copyLastYearDatas(data) {
  return request({
    url: urlPrefix + '/metashares/copyLastYearDatas',
    method: 'post',
    data
  })
}

export function updateMsRatio(data) {
  return request({
    url: urlPrefix + '/metashares/updateMsRatio',
    method: 'post',
    data
  })
}

export function addMsRatio(data) {
  return request({
    url: urlPrefix + '/metashares/addMsRatio',
    method: 'post',
    data
  })
}

export function listColumns(data) {
  return request({
    url: urlPrefix + '/metashares/listcolumns',
    method: 'post',
    data
  })
}

export function listRights() {
  return request({
    url: urlPrefix + '/metashares/listrights',
    method: 'post',
    data: {}
  })
}

export function addEmp(data) {
  return request({
    url: urlPrefix + '/metashares/add',
    method: 'post',
    data
  })
}

export function updateEmp(data) {
  return request({
    url: urlPrefix + '/metashares/update',
    method: 'post',
    data
  })
}

export function getProfile(data) {
  return request({
    url: urlPrefix + '/metashares/getEmployeeEditHistory',
    method: 'post',
    data
  })
}

export function addMetasharesPeriod(data) {
  return request({
    url: urlPrefix + '/metashares/addtitle',
    method: 'post',
    data
  })
}

export function updateMetasharesPeriod(data) {
  return request({
    url: urlPrefix + '/metashares/updatetitle',
    method: 'post',
    data
  })
}

export function updateMetasharesPercent(data) {
  return request({
    url: urlPrefix + '/metashares/updateMetasharesPercent',
    method: 'post',
    data
  })
}

export function updateGoliathPercent(data) {
  return request({
    url: urlPrefix + '/metashares/updateGoliathPercent',
    method: 'post',
    data
  })
}

export function addPscRatingTitle(data) {
  return request({
    url: urlPrefix + '/metashares/addPscRatingTitle',
    method: 'post',
    data
  })
}
export function updatePscRatingTitle(data) {
  return request({
    url: urlPrefix + '/metashares/updatePscRatingTitle',
    method: 'post',
    data
  })
}

//获取cusId机构数据,treeSelect
export function queryOrgTreeSelect(id) {
  return request({
    url: urlPrefix +  '/org/treeSelect/' + id,
    method: 'get',
  });
}

export function downloadTmpExcel(year) {
  return request({
    url: urlPrefix + '/metashares/downloadTmpExcel?year=' + year,
    method: 'get',
    responseType: 'arraybuffer',
  })
}

export function exportData(data) {
  return request({
    url: urlPrefix + '/metashares/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

export function deleteEmp(data) {
  return request({
    url: urlPrefix + '/metashares/delete',
    method: 'post',
    data
  })
}

export function updateEmpLevelOrSalary(data) {
  return request({
    url: urlPrefix + '/metashares/updateEmpLevelOrSalary',
    method: 'post',
    data
  })
}

export function revokeEmployeeLevel(data) {
  return request({
    url: urlPrefix + '/metashares/revokeEmployeeLevel',
    method: 'post',
    data
  })
}

export function revokeEmployeeBaseSalary(data) {
  return request({
    url: urlPrefix + '/metashares/revokeEmployeeBaseSalary',
    method: 'post',
    data
  })
}

export function selectLetterTemp() {
  return request({
    url: urlPrefix + '/metashares/selectlettertemp',
    method: 'post',
    data: {}
  })
}

export function updateLetterTemp(data) {
  return request({
    url: urlPrefix + '/metashares/updatelettertemp',
    method: 'post',
    data
  })
}

export function downloadLetter(data) {
  return request({
    url: urlPrefix + '/metashares/letter',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
export function selectDisabledMetashars(data) {
  return request({
    url: urlPrefix + '/metashares/selectDisabledMetashars',
    method: 'post',
    data
  })
}
export function reCalculationMetashares(data) {
  return request({
    url: urlPrefix + '/metashares/reCalculationMetashares',
    method: 'post',
    data
  })
}
export function deleteElementsByEmps(data) {
  return request({
    url: urlPrefix + '/metashares/deleteElementsByEmps',
    method: 'post',
    data
  })
}

